import styled from "styled-components";

const ImageLink = styled.div`
    background-color: transparent;

    > a {
        color: #222;
        &:hover {
            color: #222;
        }
    }
`;
export default ImageLink;
